import React from 'react';

import { button } from './styles.module.scss';

const WatchButton = ({ handleClick, data }) => {
  return (
    <button
      type="button"
      onClick={handleClick}
      className={button}
      id="button_webinar_on_demand_watch"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="24"
        fill="none"
        viewBox="0 0 18 24"
      >
        <path
          fill="#000"
          d="M16.459 10.221 3.417 1.091C1.977.085 0 1.115 0 2.872v18.258c0 1.757 1.977 2.787 3.417 1.78l13.042-9.13a2.172 2.172 0 0 0 0-3.558Z"
        />
      </svg>

      {data}
    </button>
  );
};

export default WatchButton;
